import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '../routes'
import store from '../store'
import {DEBUG} from '../env-vars'

Vue.use(VueRouter)

export const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => savedPosition || {x: 0, y: 0}
})
router.beforeEach((to, from, next) => {

    if (from.name === 'IndexServizi') {
        // mostriamo lo splash screen
        if (['IndexReport', 'IndexReportSenzaComune'].indexOf(to.name) > -1) store.dispatch('modal/showModal', 'splash-screen-report', {root: true})
        if (['IndexMapPlants', 'IndexMapPlantsSenzaComune'].indexOf(to.name) > -1) store.dispatch('modal/showModal', 'splash-screen-map-plants', {root: true})
        // nascondiamo lo splash screen dopo x mills
        const splashScreenTimeout = DEBUG ? 1000 : 3000
        setTimeout(() => {
            // no splash
            store.dispatch('modal/showModal', null)
        }, splashScreenTimeout)
    }

    // console.log('cahnging route');
    if ((to.matched.some(m => m.meta.requiresAuth) && !store.getters['auth/isAuthenticated'])
        || (to.matched.some(m => m.meta.requiresOperatoreGestionaleReport) && !store.getters['user/eUnOperatoreGestionaleReport'])) {
        /*
         * If the user is not authenticated and visits
         * a page that requires authentication
         * si ritorna alla pagina iniziale, poco fare i furbi
         */
        next({name: 'Login'})
    } else {
        next()
    }
})

Vue.router = router
